<template>
  <div class="dt" ref="dt">
    <div class="dt-content">
      <p class="text">胆码区-红球，至少选择1个，最多5个</p>
      <div class="cp-ballType border-1px">
        <div class="cp-box">
          <div class="ballItem" v-for="(item,index) in redBall1">
            <span class="ball whiteBall1" @click.stop="selectRed1(index,$event)"
                  :class="{redBall:item}">{{index+1}}</span>
          </div>
        </div>
      </div>
      <p class="text">拖码区-红球，至少选择2个</p>
      <div class="cp-ballType border-1px">
        <div class="cp-box">
          <div class="ballItem" v-for="(item,index) in redBall2">
            <span class="ball whiteBall1" @click.stop="selectRed2(index,$event)"
                  :class="{redBall:item}">{{index+1}}</span>
          </div>
        </div>
      </div>
      <p class="text">拖码区-蓝球，至少选择1个</p>
      <div class="cp-ballType">
        <div class="cp-box">
          <div class="ballItem" v-for="(item,index) in blueBall">
            <span class="ball whiteBall2" @click.stop="selectBlue(index,$event)" :class="
                  {blueBall:item}">{{index+1}}</span>
          </div>
        </div>
      </div>
      <tooltip text="最多只能选择5个红球" ref="tooltip"></tooltip>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import Vue from 'vue';
  import BScroll from 'better-scroll';
  import tooltip from 'components/tooltip/tooltip';
  const REDCOUNT = 33;
  const BLUECOUNT = 16;
  export default{
    data() {
      return {
        redBall1: [],
        redBall2: [],
        blueBall: []
      };
    },
    created() {
      // 添加红球
      for (let i = 1; i <= REDCOUNT; i++) {
        this.redBall1.push(false);
        this.redBall2.push(false);
      }
      // 添加篮球
      for (let i = 1; i <= BLUECOUNT; i++) {
        this.blueBall.push(false);
      }
      this.$nextTick(() => {
        this._initScroll();
      });
    },
    methods: {
      _initScroll() {
        if (!this.dtBallScroll) {
          this.dtBallScroll = new BScroll(this.$refs.dt, {
            click: true
          });
        } else {
          this.dtBallScroll.refresh();
        }
      },
      selectRed1(num, event) {
        if (event) {
          if (!event._constructed) {
            return;
          }
        }
        if (this.redBall1[num] === false) {
          if (this.redNums1.length < 5) {
            Vue.set(this.redBall1, num, true);
            Vue.set(this.redBall2, num, false);
          } else {
            this.$refs.tooltip.show();
          }
        } else {
          Vue.set(this.redBall1, num, false);
        }
        this.$nextTick(() => {
          this.resultParent();
        });
      },
      selectRed2(num, event) {
        if (event) {
          if (!event._constructed) {
            return;
          }
        }
        if (this.redBall2[num] === false) {
          Vue.set(this.redBall2, num, true);
          Vue.set(this.redBall1, num, false);
        } else {
          Vue.set(this.redBall2, num, false);
        }
        this.$nextTick(() => {
          this.resultParent();
        });
      },
      selectBlue(num, event) {
        if (event) {
          if (!event._constructed) {
            return;
          }
        }
        if (this.blueBall[num] === false) {
          Vue.set(this.blueBall, num, true);
        } else {
          Vue.set(this.blueBall, num, false);
        }
        this.$nextTick(() => {
          this.resultParent();
        });
      },
      resultParent() {
        this.$emit('select', this.redNums1, this.redNums2, this.blueNums);
      },
      clearNums() {
        for (let i = 0; i < REDCOUNT; i++) {
          Vue.set(this.redBall1, i, false);
          Vue.set(this.redBall2, i, false);
        }
        for (let i = 0; i < BLUECOUNT; i++) {
          Vue.set(this.blueBall, i, false);
        }
      }
    },
    computed: {
      redNums1() {
        let Nums = [];
        for (var i in this.redBall1) {
          if (this.redBall1[i]) {
            i = parseInt(i) + 1;
            if (i < 10) {
              i = '0' + i;
            }
            Nums.push(i.toString());
          }
        }
        return Nums;
      },
      redNums2() {
        let Nums = [];
        for (var i in this.redBall2) {
          if (this.redBall2[i]) {
            i = parseInt(i) + 1;
            if (i < 10) {
              i = '0' + i;
            }
            Nums.push(i.toString());
          }
        }
        return Nums;
      },
      blueNums() {
        let Nums = [];
        for (var i in this.blueBall) {
          if (this.blueBall[i]) {
            i = parseInt(i) + 1;
            if (i < 10) {
              i = '0' + i;
            }
            Nums.push(i.toString());
          }
        }
        return Nums;
      }
    },
    components: {
      tooltip
    }
  };
</script>

<style rel="stylesheet/stylus" lang="stylus">
  @import "../../../common/stylus/mixin.styl";
  .dt
    position:fixed
    z-index:50
    top:40px
    bottom:50px
    left:0
    right:0
    width:100%
    overflow:hidden
    background-color:#f8f8f0
    .dt-content
      .text
        margin:0
        padding:20px 10px 0px
        text-align:left;
        font-size:16px
        color:#938268;
      .cp-ballType
        padding:10px 0;
        width:100%
        border-1px(#cdcdcd)
        &:last-child:after
          display:none
        .cp-box
          display:flex
          flex-flow:wrap
          margin:0 auto;
          width:280px;
          .ballItem
            padding-top:5px
            width:35px
            text-align:center
            .ball
              display:block
              width:33px
              height:33px
              text-align:center
              font-size:13px
              font-weight:600
              line-height:33px
              cursor:pointer
              background-repeat:no-repeat
              background-size:100% 100%
            .whiteBall1
              background-image:url('../images/whiteB.png')
              color:#c33f51
            .whiteBall2
              background-image:url('../images/whiteB.png')
              color:#3373c1
            .redBall
              background-image:url('../images/redB.png')
              color:#fff
            .blueBall
              background-image:url('../images/blueB.png')
              color:#fff
</style>



// WEBPACK FOOTER //
// dt.vue?4e5bad13